import React, { useState } from 'react';

export const WORK_NOTE_MAX = 2000;

// Rendered only for the entry owner.
export default function WorkNoteEditor({ initialValue, onSave, onCancel }) {
  const [value, setValue] = useState(initialValue || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const save = async () => {
    setSaving(true);
    setError('');
    try {
      await onSave(value);
    } catch (err) {
      setError(err?.response?.data?.error || 'Could not save the description.');
      setSaving(false);
    }
  };

  return (
    <div className="mt-1">
      <textarea
        value={value}
        maxLength={WORK_NOTE_MAX}
        rows={4}
        onChange={(e) => setValue(e.target.value)}
        placeholder="What exactly was done? (visible to the requester too)"
        className="w-full min-w-[16rem] text-[13px] text-ink bg-surface border border-line-strong rounded-tc-sm px-3 py-2.5"
      />
      <div className="flex items-center justify-between gap-3 mt-2">
        <span className="text-[11px] text-muted tabular">{value.length}/{WORK_NOTE_MAX}</span>
        <span className="flex gap-2">
          <button type="button" disabled={saving} onClick={save}
            className="bg-ink text-canvas text-[12.5px] font-semibold rounded-tc-sm px-4 min-h-[44px] disabled:opacity-50">Save</button>
          <button type="button" disabled={saving} onClick={onCancel}
            className="bg-surface text-muted border border-line text-[12.5px] rounded-tc-sm px-4 min-h-[44px] disabled:opacity-50">Cancel</button>
        </span>
      </div>
      {error && <p className="text-xs text-danger-ink mt-1">{error}</p>}
    </div>
  );
}
